import React from "react"
import { FormattedMessage, FormattedNumber } from "react-intl"
import AccountStatement from "../../../customer/account-statement/model/AccountStatement"
import Integrations from "../../../integration/Integrations"
import PaymentTypeIcon from "../../../invoice/paymenttypeicon.component"
import PaymentLink from "../../../payment/components/PaymentLink"
import PaymentExternalDetails from "../../../payment/externaldetails.component"
import PaymentTypeLabel from "../../../payment/label.component.jsx"
import PaymentSource from "../../../payment/source.component"
import { PAYMENT_STATUS, PAYMENT_TYPE } from "../../../state/helpers/Payment"
import EventInfoBlock from "./Utils/EventInfoBlock"


type OwnProps = {
    accountStatement: AccountStatement,
}

const AccountStatementPaymentReceivedComponent = (props: OwnProps) => {

    const payment = props.accountStatement.getPayment()
    const accounStatement = props.accountStatement

    const renderDeclinedMessage = () => {
        if (payment.getStatus() === PAYMENT_STATUS.DECLINED) {
            return <FormattedMessage
                id="common.analytics.events.payment_declined.text"
                defaultMessage="A payment has been declined for an amount of {amount} while trying to pay {identifier}"
                values={{
                    identifier: <strong>{accounStatement.getIdentifier()}</strong>,
                    amount: <strong>
                        <FormattedNumber
                            value={payment.getAmount()}
                            style={"currency"}
                            currency={payment.getCurrency()}
                        />
                    </strong>,
                }}
            />
        }
        return ""
    }

    const displayHeadMessage = () => {
        let paymentType = payment.getType()
        if (paymentType === PAYMENT_TYPE.EXTERNAL_CHECKOUT && payment.getIntegratedPayment()) {
            paymentType = payment.getIntegratedPaymentType()
        }

        return renderDeclinedMessage() || <FormattedMessage
            id="quote.analytics.events.payment_received.text"
            defaultMessage="{identifier} received a {paymentType} of {amount}"
            values={
                {
                    identifier: <strong>{accounStatement.getIdentifier()}</strong>,
                    paymentType: <strong><PaymentTypeLabel value={paymentType} /></strong>,
                    amount: <strong>
                        <FormattedNumber
                            value={payment.getAmount()}
                            style={"currency"}
                            currency={payment.getCurrency()}
                        />
                    </strong>,
                }
            }
        />
    }

    const displayPaymentType = () => {
        const isDeclined = payment.getStatus() == PAYMENT_STATUS.DECLINED

        return <div className={"mr-5 align-self-center"}>
            <h2 className={"m-0 d-flex justify-content-center"}>
                <PaymentTypeIcon className={isDeclined ? "text-danger" : ""}
                    value={payment.getType()}
                    icon={payment.getPaymentTypeIcon()} />
            </h2>
        </div>
    }

    const displayPaymentAmount = () =>  {
        return <div className={"mr-5"}>
            <div className={"w-100"}>
                <label className="col-form-label custom-form-label">
                    <strong>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.payment_amount_spent"
                            defaultMessage="Payment amount"
                        />
                    </strong>
                </label>
            </div>
            <h4 className={"m-0"}>
                <FormattedNumber
                    value={payment.getAmount()}
                    style={"currency"}
                    currency={payment.getCurrency()}
                />
            </h4>
        </div>
    }

    const displayPaymentNote = () => {
        const isDeclined = payment.getStatus() == PAYMENT_STATUS.DECLINED

        return payment.getNote() && <div className={"mr-5"}>
            <div className={"w-100"}>
                <label className="col-form-label custom-form-label">
                    <strong>
                        {isDeclined ? <FormattedMessage
                            id="common.analytics.events.payment_received.error_label"
                            defaultMessage="Error"
                        /> : <FormattedMessage
                            id="invoice.analytics.events.payment_received.note_label"
                            defaultMessage="Note"
                        />}
                    </strong>
                </label>
            </div>
            <pre>
                {payment.getNote()}
            </pre>
        </div>
    }

    const displayPaymentSource = () => {
        return payment.getSource() && <div className={"mr-5"}>
            <div className={"w-100"}>
                <label className="col-form-label custom-form-label">
                    <strong>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.source_label"
                            defaultMessage="Source"
                        />
                    </strong>
                </label>
            </div>
            <p className={"mb-0"}>
                <PaymentSource value={payment.getSource()} />
            </p>
        </div>
    }

    const displayPaymentLink = () => {
        if (!payment) {
            return ""
        }

        return <EventInfoBlock
            label={<FormattedMessage
                id="common.payment_id.label"
                defaultMessage="Payment ID"
            />}
            info={<PaymentLink
                paymentId={payment.getId()}
                label={payment.getIdentifier()}
            />}
        />
    }

    const displayPaymentInformation = () => {
        return <div className={"col-12 d-flex align-items-start flex-wrap"}>
            {
                displayPaymentType()
            }
            {
                displayPaymentLink()
            }
            {
                displayPaymentAmount()
            }
            {
                displayPaymentNote()
            }
            {
                displayPaymentSource()
            }
        </div>
    }


    const displayExternalLinks = () => {

        return [payment.getExternalLink() &&
            <div className={"col-12 border-top pt-2 mt-2"} >
                <div className={"w-100"}>
                    <p className={"mb-2"}>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received_exported.integration"
                            defaultMessage="This payment was made with {integrationName}"
                            values={{
                                integrationName: Integrations.getIntegrationNameFromKey(payment.getExternalLink().attributes.integrationKey)
                            }}
                        />
                    </p>
                </div>
                <PaymentExternalDetails value={payment.getPayment()} />
            </div>
        ]}


    return <div className={"row"}>
        <div className="col-12">
            <p className={"mb-1"}>
                {
                    displayHeadMessage()
                }
            </p>
        </div>
        {
            displayPaymentInformation()
        }

        {
            displayExternalLinks()
        }
    </div>
}

export default AccountStatementPaymentReceivedComponent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/account-statement-payment-received.component.tsx